//import './login.css';
import MenuLateral from "../MenuLateral/menulateral";
import TabelaRelatorioEmplacamento from "./tabela";


function Listagem(){    
    
    return (
        <div class="container-fluid">
            <div class="row">
                <MenuLateral menu="relEmplacamento" admin={true}/>
                <div class="col-12 col-lg-2 mobile-hide invisible"></div>            
                <div id="conteudo" class="col-12 col-lg-10">
                    <TabelaRelatorioEmplacamento />
                </div>           
            </div>
        </div>
   
    )
}

export default Listagem;

